import(/* webpackMode: "eager" */ "/var/www/eduegoo/frontend/app/error.tsx");
